import { Box, Typography } from '@mui/material';

interface LoaderProps {
    minHeight?: string;
    gifSize?: number;
    fontSize?: string;
    text?: string;
    fullHeight?: boolean;
    sx?: any;
}

const Loader = ({ 
    minHeight,
    gifSize = 70, 
    fontSize = '14px',
    text = 'Loading...',
    fullHeight = false,
    sx = {}
}: LoaderProps) => {
    return (
        <Box 
            display="flex" 
            flexDirection="column"
            justifyContent="center" 
            alignItems="center" 
            height={fullHeight ? '100%' : 'auto'}
            minHeight={minHeight}
            width="100%"
            position="relative"
            sx={{
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(255, 255, 255, 0.2)',
                    backdropFilter: 'blur(4px)',
                    zIndex: 1
                },
                ...sx
            }}
        >
            <Box 
                component="img"
                src="https://easywebinar-site.easywebinar.com/images/autheticator-app-images/minimal-ew-loader.gif"
                alt="Loading..."
                sx={{ 
                    width: `${gifSize}px`,
                    height: `${gifSize}px`,
                    position: 'relative',
                    zIndex: 2
                }}
            />
            <Typography
                sx={{
                    position: 'relative',
                    zIndex: 2,
                    color: '#333333',
                    fontSize: fontSize,
                    ml: '10px'
                }}
            >
                {text}
            </Typography>
        </Box>
    );
};

export default Loader;
